export default __webpack_public_path__ + "static/media/graduation.751d7718.svg";